module.exports = __webpack_public_path__ + "img/avatar2.9145ea4c.png";